import { useContext, useEffect } from "react"
import { Stack, Typography, Grid, Avatar, Box, IconButton, Button } from "@mui/material"
import { ToolContext } from "../../../../../core/context/ToolContext"
import { AddCircleOutlineSharp } from "@mui/icons-material";
import { rqx } from "../../../../../core/request/API"
import { env } from "../../../../../core/Env"
import { FileActions } from "./FileActions"
import { SnakeLoader } from "../../../../../core/loader/SnakeLoader"
import { ToolTip } from "../../../../../core/global/ToolTip";
import { RequirementModal } from "./RequirementModal";
import { SuccessMsg } from "../../../../../core/global/SuccessMsg"
import PDFIcon from '../../../../../assets/images/icons/pdf-icon.png'
import WordIcon from '../../../../../assets/images/icons/word-icon.png'

export const Requirement = ({ currentStatus }) => {
    const { realproperty_state, tool_state } = useContext(ToolContext)
    const { fileTypes, requirements, inquiryData } = realproperty_state

    const __init = async () => {
        try {
            fileTypes.set((p) => ({ ...p, loader: true }))
            const data = await rqx.get(`<<tool>>/${env()}/propertyListing/read_listing_requirements`, { company_id: tool_state.__SESSION.data.uaccess[0].company_id, listing_id: inquiryData.data.data[0]?.listing_id });
            const res_req = await rqx.get(`<<tool>>/${env()}/propertyListing/read_curr_requirements`, { property_inquiry_id: inquiryData.data.data[0]?.property_inquiry_id });
            const insCurrReq = data.map(v => {
                const match = res_req.find(r => v.id === r.property_requirement_id)
                if (!match) return v
                const ext = match.file_name?.split('.').pop().toLowerCase();
                const name = match.file_name?.split('.');
                name.pop();
                const file_name = name.join('.'); 
                return {
                    ...v,
                    // ...(match || {})
                    existing_file: {
                        ext,
                        file_name,
                        size: Number(match?.file_size),
                        user_requirement_id: match.user_requirement_id,
                        link: match.link,
                    }
                } 
            })
            const s = insCurrReq.filter(v => v.type === 1);
            const b = insCurrReq.filter(v => v.type === 2);
            fileTypes.set((p) => ({ ...p, loader: false, sellerAvailReq: s, buyerAvailReq: b, existing_upr_id: res_req[0]?.upr_id } ))
        } catch (error) {
            console.error(error);
        }
    }

    const handleOpenModal = (type) => requirements.set((p) => ({ ...p, modal: true, modalType: type }))

    useEffect(() => (
        __init()
        // eslint-disable-next-line
    ), [])

    return (
        <>
            <Grid item xs={12} sm={12}>
                { fileTypes.data.loader ? 
                    <Box display="flex" justifyContent="center" mt="4rem"><SnakeLoader size="10px" bg="#11783C" distance="6px" /></Box> 
                :
                    <>
                        <Typography sx={{ color: requirements.data.error && 'error.main' }}>Requirements:</Typography>
                        <Stack direction='row' gap='2rem' mt='0.5rem'>
                            <Stack flex={1} gap='0.5rem'>
                                <Stack direction='row' alignItems='center' gap='1rem' justifyContent='space-between'>
                                    <Typography fontSize={14} sx={{ color: requirements.data.error ? 'error.main' : '#5B6167' }}>For Seller:</Typography>
                                    { currentStatus === 'deal-closed' ?
                                        <AddCircleOutlineSharp sx={{ color: 'gray', cursor: "not-allowed" }}/>
                                    :
                                        <ToolTip title="Add Seller Requirement">
                                            <IconButton onClick={() => handleOpenModal('seller')} sx={{ p: 0, mr: '13px'}}>
                                                <AddCircleOutlineSharp sx={{ color: 'primary.main', '&:hover' : { color: 'gray' } }}/>
                                            </IconButton>
                                        </ToolTip>
                                    }
                                </Stack>
                                {  fileTypes.data.sellerAvailReq.length === 0 ?
                                    <Stack bgcolor="#fff" p='0.75rem' alignItems='center' gap='0.5rem' sx={{ border: '1px solid #E8E8E8', borderRadius: '12px' }}>
                                        <Typography fontSize={14}>Start by specifying which file types the seller needs to provide.</Typography>
                                        <Button onClick={() => handleOpenModal('seller')} variant="outlined" size='small' sx={{ borderRadius: '16px', p: '4px 16px' }}>Add Seller Requirements</Button>
                                    </Stack>
                                :
                                    fileTypes.data.sellerAvailReq?.map((v, k) => (
                                        <Stack key={k} direction='row' bgcolor="#fff" p='0.75rem' gap='0.25rem' sx={{ border: '1px solid #E8E8E8', borderRadius: '12px' }}>
                                            <Stack width='100%' gap='0.5rem'>
                                                <Typography fontSize={14}>{ v.name }</Typography>
                                                { (v.file || v.existing_file) &&
                                                    <>
                                                        <Stack direction='row' gap='0.5rem' alignItems='center'>
                                                            <Stack alignItems='center' justifyContent='center'>
                                                                <Avatar alt={v.file?.ext || v.existing_file?.ext} src={(v.file?.ext || v.existing_file?.ext) === 'pdf' ? PDFIcon : WordIcon} variant='rounded' sx={{ width: 28, height: 28 }}></Avatar>
                                                            </Stack>
                                                            <Stack flex={1}>
                                                                <Typography fontSize={12} fontWeight={600}>{v.file?.file_name || v.existing_file?.file_name}</Typography>
                                                                <Typography fontSize={10} fontWeight={400} sx={{ color: '#5B6167' }}> {((v.file?.file[0]?.size || v.existing_file?.size) / (1024 * 1024)).toFixed(2)} MB </Typography>
                                                            </Stack>
                                                        </Stack>
                                                    </>
                                                } 
                                            </Stack>
                                            <Stack alignItems='center' justifyContent='center'>
                                                <FileActions type='sellerAvailReq' id={v.id} file={v.file} existing_file={v.existing_file} currentStatus={currentStatus}/>
                                            </Stack>
                                        </Stack>
                                    )) 
                                }
                            </Stack>
                            <Stack flex={1} gap='0.5rem'>
                                <Stack direction='row' alignItems='center' gap='1rem' justifyContent='space-between'>
                                    <Typography fontSize={14} sx={{ color: requirements.data.error ? 'error.main' : '#5B6167' }}>For Buyer:</Typography>
                                    { currentStatus === 'deal-closed' ?
                                        <AddCircleOutlineSharp sx={{ color: 'gray', cursor: "not-allowed" }}/>
                                    :
                                        <ToolTip title="Add Buyer Requirement">
                                            <IconButton onClick={() => handleOpenModal('buyer')} sx={{ p: 0, mr: '13px'}}>
                                                <AddCircleOutlineSharp sx={{ color:'primary.main', '&:hover' : { color: 'gray' } }}/>
                                            </IconButton>
                                        </ToolTip>
                                    }
                                </Stack>
                                {  fileTypes.data.buyerAvailReq.length === 0 ?
                                    <Stack bgcolor="#fff" p='0.75rem' alignItems='center' gap='0.5rem' sx={{ border: '1px solid #E8E8E8', borderRadius: '12px' }}>
                                        <Typography fontSize={14}>Start by specifying which file types the buyer needs to provide.</Typography>
                                        <Button onClick={() => handleOpenModal('buyer')} variant="outlined" size='small' sx={{ borderRadius: '16px', p: '4px 16px' }}>Add Buyer Requirements</Button>
                                    </Stack>
                                :
                                    fileTypes.data.buyerAvailReq?.map((v, k) => (
                                        <Stack key={k} direction='row' bgcolor="#fff" p='0.75rem' gap='0.25rem' sx={{ border: '1px solid #E8E8E8', borderRadius: '12px' }}>
                                            <Stack width='100%' gap='0.5rem'>
                                                <Typography fontSize={14}>{ v.name }</Typography>
                                                { (v.file || v.existing_file) &&
                                                    <>
                                                        <Stack direction='row' gap='0.5rem' alignItems='center'>
                                                            <Stack alignItems='center' justifyContent='center'>
                                                                <Avatar alt={v.file?.ext || v.existing_file?.ext} src={(v.file?.ext || v.existing_file?.ext) === 'pdf' ? PDFIcon : WordIcon} variant='rounded' sx={{ width: 28, height: 28 }}></Avatar>
                                                            </Stack>
                                                            <Stack flex={1}>
                                                                <Typography fontSize={12} fontWeight={600}>{v.file?.file_name || v.existing_file?.file_name}</Typography>
                                                                <Typography fontSize={10} fontWeight={400} sx={{ color: '#5B6167' }}> {((v.file?.file[0]?.size || v.existing_file?.size) / (1024 * 1024)).toFixed(2)} MB </Typography>
                                                            </Stack>
                                                        </Stack>
                                                    </>
                                                } 
                                            </Stack>
                                            <Stack alignItems='center' justifyContent='center'>
                                                <FileActions type='buyerAvailReq' id={v.id} file={v.file} existing_file={v.existing_file} currentStatus={currentStatus}/>
                                            </Stack>
                                        </Stack>
                                    )) 
                                }
                            </Stack>
                        </Stack>
                    </>
                }
            </Grid>
            { requirements.data.modal && <RequirementModal reload={__init}/> } 
            { requirements.data.sendSuccess && <SuccessMsg open={requirements.data.sendSuccess} setOpen={(v) => requirements.set(p => ({ ...p, sendSuccess: v }))} message="Success" bgcolor="#d2f9e2" hideDuration={null}/> }
        </>
    )
}
